import ArgonBox from "component/Argon/ArgonBox";
import ArgonTypography from "component/Argon/ArgonTypography";

function FormLabel({ title, subtitle }) {
  return (
    <ArgonBox>
      <ArgonTypography variant="h6" fontWeight="medium">
        {title}
      </ArgonTypography>
      <ArgonTypography variant="button" fontWeight="regular" color="text">
        {subtitle}
      </ArgonTypography>
    </ArgonBox>
  );
}

export default FormLabel;